module.exports = __webpack_public_path__ + "img/ico_com.7593aae6.png";